import axios from '@/libs/api.request'

// 获取配置
export const apiGetSystem = (key) => {
    return axios.request({
        url: `/setting/${key}`,
        method:'get',
    })
}

// 更新配置
export const apiSetSystem = (key,data) => {
    return axios.request({
        url: `/setting/${key}`,
        method:'put',
        data
    })
}
